class CoursesView {
  courseCards = document.querySelectorAll(".course");
  curScaledCard = [document.querySelector(".scale")];
  allDots = document.querySelectorAll(".dot");
  faqs = document.querySelectorAll(".faq");
  dots = document.querySelectorAll(".dots");
  courseGroup = document.querySelector(".course-i");
  coursePrivate = document.querySelector(".course-ii");

  scaleCards() {
    if (window.innerWidth < 764) {
      if (!this.curScaledCard[0]) return;
      this.curScaledCard[0].classList.remove("scale");

      // rearrange card order
      this.courseGroup.dataset.slide = "slide-ii";
      this.coursePrivate.dataset.slide = "slide-i";
      this.courseGroup.before(this.coursePrivate);

      return;
    }

    this.courseCards.forEach((card) => {
      card.addEventListener("mouseover", (e) => {
        // remove scale from other card
        this.curScaledCard[0].classList.remove("scale");

        // add scale to current card
        e.target.closest(".course").classList.add("scale");

        // mark new scaled card
        this.curScaledCard[0] = document.querySelector(".scale");
      });
    });
  }

  faq() {
    this.faqs.forEach((faq) => {
      faq.addEventListener("click", () => {
        faq.classList.toggle("active");
      });
    });
  }

  courseCardObserver() {
    if (!window.innerWidth > 412) return;

    const options = {
      threshold: 0.5,
      // rootmargin: "0px 0px -500px 0px",
    };

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const dotId = entry.target.dataset.slide;
        // remove previous dot color
        document.querySelector(".cur-dot").classList.remove("cur-dot");
        // change cur dot
        document.querySelector(`#${dotId}`).classList.add("cur-dot");
      });
    }, options);

    this.courseCards.forEach((card) => {
      observer.observe(card);
    });
  }

  dotDetector() {
    this.allDots.forEach((dot) => {
      dot.addEventListener("click", (dot) => {
        const slideId = dot.target.id;
        const nextSlide = document.querySelector(`[data-slide='${slideId}']`);

        nextSlide.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      });
    });
  }
}
export default new CoursesView();
